"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgHome(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M31.714 14.918v17.131c0 .996-.803 1.803-1.794 1.803H10.179a1.799 1.799 0 01-1.795-1.803V14.918", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "square" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M17.357 33.05v-7.312c0-.996.804-1.804 1.795-1.804h1.794c.992 0 1.795.808 1.795 1.804v7.311", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "square" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M2.843 16.317A1 1 0 003.97 17.97l-1.127-1.653zm33.161 1.638a1 1 0 001.17-1.623l-1.17 1.623zM21.59 6.339l-.584.811.584-.811zM3.97 17.969L19.858 7.136 18.73 5.483 2.843 16.317 3.97 17.97zM21.006 7.15l14.998 10.805 1.17-1.623-15-10.805-1.168 1.623zm-1.148-.015a1 1 0 011.148.015l1.169-1.623a3 3 0 00-3.444-.044l1.127 1.652z", fill: "currentColor" }, void 0)] }), void 0));
}
exports.default = SvgHome;
//# sourceMappingURL=Home.js.map